import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import numeral from "numeral";

import { signOut } from "../SignIn/actions";
import { clearMessage, getUserConfig } from "./actions";

import ModuleButton from "./components/ModuleButton";

import logo from "../../img/logo-icesi.png";
import profile from "../../img/User-Profile.jpg";

import "../../css/simple-sidebar.css";

class Layout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSignOut: false,
      showSideBar: true
    };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      this.props.signOut();
    } else {
      if (!this.props.user) {
        this.props.getUserConfig();
      }
    }
  }

  componentDidMount() {
    window.root.addEventListener("click", this.handleDocumentClick);
  }

  componentWillUnmount() {
    window.root.removeEventListener("click", this.handleDocumentClick);
  }

  componentWillUpdate(nextProps) {
    if (!nextProps.isAuthenticated) {
      this.props.signOut();
    }
  }

  componentDidUpdate() {
    this.props.clearMessage();
  }

  handleDocumentClick = e => {
    const dd1 = ReactDOM.findDOMNode(this.dd1);
    if (!dd1.contains(e.target)) {
      this.setState({ showSignOut: false });
    }
  };

  render() {
    const { user } = this.props;
    if (!user) return null;

    if (this.props.message) {
      const { message } = this.props;
      switch (message.get("type")) {
        case "danger":
          toast.error(message.get("message"), {
            bodyClassName: "toastify-content toastify-danger"
          });
          break;
        case "warning":
          toast.warn(message.get("message"), {
            bodyClassName: "toastify-content toastify-warning"
          });
          break;
        case "success":
          toast.success(message.get("message"), {
            bodyClassName: "toastify-content toastify-success"
          });
          break;
        default:
          toast.info(message.get("message"), {
            bodyClassName: "toastify-content toastify-info"
          });
      }
    }

    return (
      <div className="body">
        <nav
          className="navbar navbar-default navbar-fixed-top"
          style={{
            backgroundColor: "#F7F9FA",
            borderBottom: "1px solid #d2d6de"
          }}
        >
          <div className="container-fluid">
            <div style={{ background: "#F7F9FA" }}>
              <a
                className="navbar-brand"
                style={{
                  width: "181px",
                  background: "#f7f9fa",
                  padding: "5px 25px"
                }}
              >
                <img src={logo} height="40" alt="logo" />
              </a>
            </div>
            <div
              className="header-link hide-menu"
              onClick={() =>
                this.setState({ showSideBar: !this.state.showSideBar })
              }
            >
              <i className="fa fa-bars"></i>
            </div>
          </div>
        </nav>
        <div
          id="wrapper"
          className={`${this.state.showSideBar ? "" : "toggled"}`}
        >
          <div id="sidebar-wrapper">
            <div
              className="text-center"
              style={{
                background: "#fff",
                paddingTop: "25px",
                paddingBottom: "40px"
              }}
            >
              <img
                className="profile-user-img img-responsive img-circle"
                src={profile}
                alt="profile"
              />
              <div style={{ paddingTop: "15px" }}>
                <div>
                  <small
                    style={{
                      display: "block",
                      padding: "0 10px",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      width: "100%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                  >
                    {user.get("name")}
                  </small>
                </div>
                <div>
                  <small
                    style={{
                      textTransform: "uppercase",
                      fontWeight: "300",
                      color: "#666"
                    }}
                  >
                    {/^\d+$/g.test(user.get("username"))
                      ? numeral(user.get("username")).format("0,0")
                      : user.get("username")}
                  </small>
                </div>
                <div className="usertype">
                  <div className="dropdown">
                    <a
                      className="text-center dropdown-toggle"
                      onClick={e => {
                        e.preventDefault();
                        this.setState({ showSignOut: true });
                      }}
                    >
                      <small>
                        {this.props.user.getIn("roles.0.name".split("."))}&nbsp;
                        <i className="fa fa-caret-down"></i>
                      </small>
                    </a>
                    <ul
                      className="dropdown-menu animated flipInX"
                      ref={dd1 => (this.dd1 = dd1)}
                      style={{
                        width: "172px",
                        margin: "0 5px",
                        display: this.state.showSignOut ? "block" : "none"
                      }}
                    >
                      <li>
                        <a
                          onClick={e => {
                            e.preventDefault();
                            this.props.signOut();
                          }}
                        >
                          Cerrar sesión
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <ul className="sidebar-nav">
              {this.props.modulos
                .filter(x => x.getIn("config.menu".split(".")))
                .sortBy(x => x.get("cod_modulo_hijo"))
                .map(x => {
                  return (
                    <ModuleButton
                      key={x.get("cod_nodo")}
                      id={x.get("cod_nodo")}
                      caption={x.get("nod_modulo")}
                      expandible={
                        x.get("parent_module_id") === 9999 &&
                        x.get("submodulos").count() > 0
                      }
                      options={x
                        .get("submodulos")
                        .filter(a => a.getIn("config.menu".split(".")))
                        .sortBy(a => a.get("cod_modulo_hijo"))}
                      url={x.getIn("config.url".split(".")) || ""}
                    />
                  );
                })}
            </ul>
          </div>

          <div id="page-content-wrapper">
            {this.props.children}
            <div
              className="text-center"
              style={{
                width: "100%",
                position: "absolute",
                bottom: "0px",
                fontSize: "0.9em"
              }}
            >
              <span style={{ color: "#c8c8c8" }}>
                Desarrollado por{" "}
                <a
                  href="http://www.mawesi.net"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#b5b5b5" }}
                >
                  MAWESI S.A.S.
                </a>{" "}
                | &copy; 2018 Mawesi
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    message: state.layout.get("message"),
    isAuthenticated: state.signin.get("isAuthenticated"),
    user: state.signin.get("user"),
    modulos: state.layout.get("modulos")
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signOut: () => dispatch(signOut()),
    clearMessage: () => dispatch(clearMessage()),
    getUserConfig: () => dispatch(getUserConfig())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
